import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import AppLayout from "./AppLayout";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { ArrowLeft, Bell, Calendar, Clock, X } from "lucide-react";
import authService from "../Services/authService";
import { useNotification } from "../Services/NotificationContext";

const NotificationsScreen = () => {
  const navigate = useNavigate();
  const { fetchNotificationCount } = useNotification();
  const [notifications, setNotifications] = useState([]);
  const audioRef = useRef(null);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = () => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + "notificationslist");

    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        assign_to: authService.getCurrentuser().id,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        setNotifications(result.data || []);
      })
      .catch((err) => {
        console.error("Failed to load notifications:", err.message);
      });
  };

  const handleupdatenotification = (id) => {
    const token = authService.getCurrentUsertoken();
    const url = new URL(authService.getApiUrl() + "updatenotification/" + id);

    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.clientlogout();
          window.location.href = "/login";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        if (result) {
          fetchNotificationCount();
          navigate("/appointments/" + id);
        }
      })
      .catch((err) => {
        console.error("Failed to update notification:", err.message);
      });
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case "new":
        return <Calendar className="h-5 w-5 text-pranaam-red" />;
      case "reschedule":
        return <Clock className="h-5 w-5 text-amber-500" />;
      case "cancel":
        return <X className="h-5 w-5 text-red-500" />;
      case "reminder":
        return <Bell className="h-5 w-5 text-purple-500" />;
      default:
        return <Bell className="h-5 w-5 text-gray-500" />;
    }
  };

  const formatTime12Hour = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateLong = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <AppLayout>
      <div className="flex items-center mb-6">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          className="mr-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100"
        >
          <ArrowLeft className="h-5 w-5" />
          <span className="sr-only">Back</span>
        </Button>
        <div className="flex items-center">
          {/* <div className="relative h-[100px] w-[100px] mr-3">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div> */}
          <h1 className="text-xl font-bold text-gray-800">Notifications</h1>
        </div>
      </div>

      <div className="space-y-4">
        {notifications.map((notification) => (
          <Card key={notification.id} className="p-4 border-gray-200">
            <Link to="#" onClick={(e) => {
              e.preventDefault();
              handleupdatenotification(notification.id);
            }}>
              <div className="flex">
                <div className="mr-3 mt-0.5">
                  {getNotificationIcon(notification.type)}
                </div>
                <div className="flex-1 text-left">
                  <h3 className="font-medium text-gray-800">{notification.title || "New Appointment"}</h3>
                  <p className="text-sm text-gray-700 mb-1">
                    You have a new appointment with {notification.user_name} at{" "}
                    {formatTime12Hour(notification.slot_time)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {formatDateLong(notification.slot_date)}
                  </p>
                </div>
              </div>
            </Link>
          </Card>
        ))}
      </div>

      <audio ref={audioRef} src="/sounds/notification.mp3" preload="auto" />

      {notifications.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <Bell className="h-12 w-12 text-gray-300 mb-4" />
          <h2 className="text-lg font-medium mb-1 text-gray-800">No Notifications</h2>
          <p className="text-sm text-gray-500">You don't have any notifications at the moment</p>
        </div>
      )}
    </AppLayout>
  );
};

export default NotificationsScreen;
